/**
 * PostcardViewPage — /card/:shareCode
 * Public page. Anyone with the link can view the postcard.
 */
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import PostcardViewModal from '../components/PostcardViewModal';
import { ROUTES } from '@app/router/routes';

export default function PostcardViewPage() {
  const { shortId: shareCode } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const recordId = location.state?.record_id;
  const openShare = location.state?.openShare ?? false;

  return (
    <PostcardViewModal
      isOpen={true}
      onClose={() => navigate(ROUTES.HOME)}
      onMakePostcard={() => navigate(ROUTES.POSTCARD_CREATE)}
      shareCode={shareCode}
      recordId={recordId}
      openShare={openShare}
    />
  );
}
